import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import renderProps from '@docpocalypse/props-table';
import { MDXProvider } from '@mdx-js/react';
import React, { useMemo } from 'react';
import LinkedHeading from './LinkedHeading';
import Pre from './Pre';
import PropDescription from './PropDescription';

var tokenMap = require('./PropsList-tokenMap.module.css');

var styles = require('./PropsList-styles.module.css');

function PropsTable(_ref) {
  var metadata = _ref.metadata;
  var name = metadata.name;
  var props = renderProps(metadata.props || [], {
    tokenMap: tokenMap
  });
  var components = useMemo(function () {
    return {
      pre: function pre(p) {
        return _j(Pre, Object.assign({}, p, {
          name: name
        }));
      }
    };
  }, [name]);
  return _j(_f, null, props.map(function (prop) {
    var _prop$propData$descri;

    return _j(React.Fragment, {
      key: prop.name
    }, _j(LinkedHeading, {
      h: 3,
      id: prop.name
    }, _j("div", {
      css: [require("./PropsList-CssProp1_div.module.css"), []]
    }, _j("span", {
      className: styles.PropListName
    }, prop.name), prop.propData.required && _j("strong", {
      className: styles.PropListRequiredBadge
    }, "required"))), _j(MDXProvider, {
      components: components
    }, _j(PropDescription, {
      mdx: (_prop$propData$descri = prop.propData.description) === null || _prop$propData$descri === void 0 ? void 0 : _prop$propData$descri.mdx,
      html: prop.description
    })), _j("div", {
      css: [require("./PropsList-CssProp2_div.module.css"), []]
    }, _j("div", null, _j("strong", null, "type:"), _j("span", {
      className: styles.PropListTypeDefinition
    }, prop.type)), prop.defaultValue && _j("div", {
      className: "mt-1"
    }, _j("strong", null, "default:"), _j("code", {
      className: styles.PropListDefaultValue
    }, prop.defaultValue))));
  }));
}

export default PropsTable;